import React from "react";
import { useTranslation } from "react-i18next";
import { useWorkspaceTabs } from "./WorkspaceTabsContext";

const normalizeWorkspaceIconClass = (iconValue) => {
  if (typeof iconValue !== "string") {
    return "fa fa-folder-open-o";
  }
  const raw = iconValue.trim();
  if (!raw) {
    return "fa fa-folder-open-o";
  }
  if (raw.includes(" ")) {
    return raw.startsWith("fa ") ? raw : `fa ${raw}`;
  }
  if (raw.startsWith("fa-")) {
    return `fa ${raw}`;
  }
  if (raw.startsWith("fa")) {
    const normalized = raw
      .replace(/^fa/, "")
      .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
      .replace(/^-+/, "")
      .toLowerCase();
    return normalized ? `fa fa-${normalized}` : "fa fa-folder-open-o";
  }
  return `fa fa-${raw.toLowerCase()}`;
};

const WorkspaceTabsBar = () => {
  const { t } = useTranslation();
  const {
    tabs,
    activePath,
    activateTab,
    closeTab,
    refreshTab,
    tabLimitMessage,
    clearTabLimitMessage,
  } = useWorkspaceTabs();

  if (!Array.isArray(tabs) || tabs.length === 0) {
    return null;
  }

  return (
    <div className="workspace-tabs-bar">
      {tabLimitMessage ? (
        <div className="workspace-tabs-alert">
          <span>{tabLimitMessage}</span>
          <button
            type="button"
            className="workspace-tabs-alert-close"
            onClick={clearTabLimitMessage}
            title={t("workspaceTabs.closeAlert")}
          >
            <i className="fa fa-times" />
          </button>
        </div>
      ) : null}
      <div className="workspace-tabs-scroll">
        {tabs.map((tab) => {
          const isActive = tab.path === activePath;
          return (
            <div
              key={tab.path}
              className={`workspace-tab-item ${isActive ? "is-active" : ""}`}
            >
              <button
                type="button"
                className="workspace-tab-link"
                onClick={() => activateTab(tab.path)}
                title={tab.title}
              >
                <i className={`${normalizeWorkspaceIconClass(tab.icon)} workspace-tab-title-icon`} aria-hidden="true" />
                <span>{tab.title}</span>
              </button>
              <button
                type="button"
                className="workspace-tab-action"
                onClick={() => refreshTab(tab.path)}
                title={t("workspaceTabs.refreshTab")}
              >
                <i className="fa fa-refresh" />
              </button>
              <button
                type="button"
                className="workspace-tab-action"
                onClick={() => closeTab(tab.path)}
                title={t("workspaceTabs.closeTab")}
              >
                <i className="fa fa-times" />
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default WorkspaceTabsBar;

